import { Component, OnDestroy, OnInit, ElementRef, Input, Output, EventEmitter, Directive, OnChanges } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import * as Pikaday from 'pikaday';
import * as Moment from 'moment';
import { CONFIG } from '../../constants/config.constants';

@Directive({
  selector: '[jhiDatePicker][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: DatePickerDirective,
      multi: true
    }
  ]
})
export class DatePickerDirective implements OnInit, OnDestroy, Validator, OnChanges {
  @Input() ngModel;
  @Output() ngModelChange = new EventEmitter();

  @Input() serverModel;
  @Output() serverModelChange = new EventEmitter();
  picker: any;
  validator: ValidatorFn;

  constructor(private elementRef: ElementRef) {
    this.validator = validateFactory();
  }

  ngOnChanges() {
    if (this.serverModel && !this.ngModel) {
      // Workaround fix drity checked
      setTimeout(() => {
        const valueInput = Moment(this.serverModel, CONFIG.serverDateFormat);
        this.ngModelChange.emit(valueInput.format(CONFIG.dateFormat).valueOf());
        this.picker.setDate(valueInput);
      });
    }
  }

  ngOnInit() {
    if (this.serverModel) {
      const valueInput = Moment(this.serverModel, CONFIG.serverDateFormat).format(CONFIG.dateFormat).valueOf();
      this.ngModelChange.emit(valueInput);
    }

    this.picker = new Pikaday({
        field: this.elementRef.nativeElement,
        format: CONFIG.dateFormat,
        i18n: {
          previousMonth : 'Tháng trước',
          nextMonth     : 'Tháng tiếp',
          months        : ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
          weekdays      : ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'],
          weekdaysShort : ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7']
        },
        toString: (date, format) => {
          const valueInput = Moment(date).format(CONFIG.dateFormat).valueOf();
          this.ngModelChange.emit(valueInput);

          const dateValue = Moment(date).format(CONFIG.serverDateFormat).valueOf();
          this.serverModelChange.emit(dateValue);

          return Moment(date).format(CONFIG.dateFormat).valueOf();
        },
        parse: (dateString, format) => {
          return Moment(dateString, format, true).toDate();
        }
    });
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

  ngOnDestroy() {
    if (this.picker && this.picker.destroy) {
      this.picker.destroy();
    }
  }
}

function validateFactory(): ValidatorFn {
  return (c: AbstractControl) => {
    if (c.value === null
      || c.value === ''
      || c.value === undefined
      || (c.value && c.value.trim && c.value.trim() === '') ||
      Moment(c.value, CONFIG.dateFormat, true).isValid()) {
      return null;
    } else {
      return {
        date: true
      }
    }
  }
}
